// Theme: orbital-slate
// Auto-generated by scripts/materialize-theme-presets.ts
// Source of truth for theme configuration

import type { ThemePreset } from '@/lib/themes/types'

export const THEME_PRESET: ThemePreset = {
  id: 'orbital-slate',
  name: 'ORBITAL SLATE',
  tagline: 'ORBITAL SLATE',
  description: 'Ardosia orbital cinza-azulada com assinatura minimalista espacial.',
  category: 'cosmic-scale',
  tier: 'rare',
  basePrice: 2625,
  swatches: ['#0F1418', '#1A2028', '#64748B', '#F1F5F9'],
  baseStyle: {
    cardClasses: '',
    shapeVars: {
      '--border-w': '1px',
      '--radius': '10px',
      '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
      '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)'
    },
    shellClasses: 'font-sans theme-orbital-slate'
  },
  colorVars: {
    '--accent': '#64748B',
    '--accent-foreground': '#0F1418',
    '--background': '#0F1418',
    '--border': '#3A5070',
    '--card': '#1A2028',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F1F5F9',
    '--card-glow': 'color-mix(in srgb, var(--primary) 8%, transparent)',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F1418',
    '--foreground': '#F1F5F9',
    '--hold-fill': '#64748B',
    '--input': '#3A5070',
    '--modal-bg': '#0F1418',
    '--modal-border': '#3A5070',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A5070',
    '--muted-foreground': '#F1F5F9',
    '--nav-active': '#64748B',
    '--nav-bg': '#1A2028',
    '--popover': '#1A2028',
    '--popover-foreground': '#F1F5F9',
    '--primary': '#64748B',
    '--primary-foreground': '#0F1418',
    '--ring': '#64748B',
    '--secondary': '#3A5070',
    '--secondary-foreground': '#F1F5F9',
    '--streak': '#64748B',
    '--success': '#22c55e',
    '--success-foreground': '#0F1418',
    '--xp': '#64748B',
    '--xp-bg': '#1A2028'
  },
  resolvedVars: {
    '--accent': '#64748B',
    '--accent-foreground': '#0F1418',
    '--accent-foreground-hsl': '207 23% 8%',
    '--accent-foreground-oklch': 'from #0F1418 l c h',
    '--accent-hsl': '215 16% 47%',
    '--accent-oklch': 'from #64748B l c h',
    '--background': '#0F1418',
    '--background-hsl': '207 23% 8%',
    '--background-oklch': 'from #0F1418 l c h',
    '--border': '#3A5070',
    '--border-hsl': '216 32% 33%',
    '--border-oklch': 'from #3A5070 l c h',
    '--border-w': '1px',
    '--card': '#1A2028',
    '--card-border-active': 'color-mix(in srgb, var(--primary) 62%, transparent)',
    '--card-completed': 'color-mix(in srgb, var(--card) 92%, var(--background) 8%)',
    '--card-foreground': '#F1F5F9',
    '--card-foreground-hsl': '210 40% 96%',
    '--card-foreground-oklch': 'from #F1F5F9 l c h',
    '--card-glow': 'color-mix(in srgb, var(--primary) 8%, transparent)',
    '--card-hsl': '214 21% 13%',
    '--card-oklch': 'from #1A2028 l c h',
    '--coin': 'var(--rarity-legendary)',
    '--destructive': '#ef4444',
    '--destructive-foreground': '#0F1418',
    '--destructive-foreground-hsl': '207 23% 8%',
    '--destructive-foreground-oklch': 'from #0F1418 l c h',
    '--destructive-hsl': '0 84% 60%',
    '--destructive-oklch': 'from #ef4444 l c h',
    '--foreground': '#F1F5F9',
    '--foreground-hsl': '210 40% 96%',
    '--foreground-oklch': 'from #F1F5F9 l c h',
    '--hold-fill': '#64748B',
    '--hold-fill-hsl': '215 16% 47%',
    '--hold-fill-oklch': 'from #64748B l c h',
    '--input': '#3A5070',
    '--input-hsl': '216 32% 33%',
    '--input-oklch': 'from #3A5070 l c h',
    '--modal-bg': '#0F1418',
    '--modal-bg-hsl': '207 23% 8%',
    '--modal-bg-oklch': 'from #0F1418 l c h',
    '--modal-border': '#3A5070',
    '--modal-border-hsl': '216 32% 33%',
    '--modal-border-oklch': 'from #3A5070 l c h',
    '--modal-overlay-bg': 'rgba(0, 0, 0, 0.75)',
    '--modal-shadow': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--muted': '#3A5070',
    '--muted-foreground': '#F1F5F9',
    '--muted-foreground-hsl': '210 40% 96%',
    '--muted-foreground-oklch': 'from #F1F5F9 l c h',
    '--muted-hsl': '216 32% 33%',
    '--muted-oklch': 'from #3A5070 l c h',
    '--nav-active': '#64748B',
    '--nav-active-hsl': '215 16% 47%',
    '--nav-active-oklch': 'from #64748B l c h',
    '--nav-bg': '#1A2028',
    '--nav-bg-hsl': '214 21% 13%',
    '--nav-bg-oklch': 'from #1A2028 l c h',
    '--popover': '#1A2028',
    '--popover-foreground': '#F1F5F9',
    '--popover-foreground-hsl': '210 40% 96%',
    '--popover-foreground-oklch': 'from #F1F5F9 l c h',
    '--popover-hsl': '214 21% 13%',
    '--popover-oklch': 'from #1A2028 l c h',
    '--primary': '#64748B',
    '--primary-foreground': '#0F1418',
    '--primary-foreground-hsl': '207 23% 8%',
    '--primary-foreground-oklch': 'from #0F1418 l c h',
    '--primary-hsl': '215 16% 47%',
    '--primary-oklch': 'from #64748B l c h',
    '--radius': '10px',
    '--ring': '#64748B',
    '--ring-hsl': '215 16% 47%',
    '--ring-oklch': 'from #64748B l c h',
    '--secondary': '#3A5070',
    '--secondary-foreground': '#F1F5F9',
    '--secondary-foreground-hsl': '210 40% 96%',
    '--secondary-foreground-oklch': 'from #F1F5F9 l c h',
    '--secondary-hsl': '216 32% 33%',
    '--secondary-oklch': 'from #3A5070 l c h',
    '--shadow-card': '0 10px 28px rgba(0, 0, 0, 0.22)',
    '--shadow-card-active': '0 10px 28px color-mix(in srgb, var(--primary) 35%, transparent)',
    '--streak': '#64748B',
    '--streak-hsl': '215 16% 47%',
    '--streak-oklch': 'from #64748B l c h',
    '--success': '#22c55e',
    '--success-foreground': '#0F1418',
    '--success-foreground-hsl': '207 23% 8%',
    '--success-foreground-oklch': 'from #0F1418 l c h',
    '--success-hsl': '142 71% 45%',
    '--success-oklch': 'from #22c55e l c h',
    '--tint-primary-subtle': 'hsla(215 16% 47% / 0.15)',
    '--xp': '#64748B',
    '--xp-bg': '#1A2028',
    '--xp-bg-hsl': '214 21% 13%',
    '--xp-bg-oklch': 'from #1A2028 l c h',
    '--xp-hsl': '215 16% 47%',
    '--xp-oklch': 'from #64748B l c h'
  }
}
